import { IIndexable } from '../model/IIndexable';
import { RubroData } from '../model/RubroData';

export function rubroDataMapping(item: IIndexable) {
  return new RubroData(
    item.labelName,
    item.id    
  );
}
